import {useEffect, useRef} from "react";

export function useDebounce<T, F extends (...args: [T, ...any[]]) => void>(
    value: T,
    delay: number,
    callback?: F
) {
    const callbackRef = useRef<F>(undefined);
    callbackRef.current = callback;

    useEffect(() => {
        const timer = setTimeout(() => {
            callbackRef.current?.(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
}
